var map = {
	"./01_trade_info.json": "jcbY",
	"./02_kline_data.json": "3EGE",
	"./03_depth_info.json": "fsqo",
	"./04_24hr_ticker.json": "P0Vd",
	"./05_last_price.json": "fqiK",
	"./06_book_ticker.json": "o9Mz",
	"./07_depth_incr_info.json": "soQQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ia6C";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/websocket/market \.json$
// module id = Ia6C
// module chunks = 3